import React, { Component } from 'react';
import PropTypes, { array, object } from 'prop-types';
import { IconHome, IconButton } from '@americanexpress/dls-react';
import NoData from './NoData';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    const items = this.state;
    const errorTextProps = this.props;
    if (items.hasError) {
      return (
        <div>
          <NoData description="Something went wrong. Please try again!!" />
          <div className="flex flex-justify-center">
            <IconButton
              styleType="primary"
              aria-label="Primary"
              icon={<IconHome />}
              onClick={() => window.location.reload()}
            >
              Home
            </IconButton>
          </div>
        </div>
      );
    }
    return errorTextProps.children;
  }
}

ErrorBoundary.propTypes = {
  children:   PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  history: PropTypes.shape({
    push: PropTypes.func,
    location: PropTypes.object,
    pathname: PropTypes.func,
  }),
};

export default ErrorBoundary;
